import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';

const EyeIcon = ({
	value,
	onClick = () => false,
	tooltip = 'Ver Detalle',
	disabled,
	color = 'warning',
	className = '',
}) => {
	return (
		<Tooltip title={tooltip}>
			<span>
				<button
					onClick={onClick}
					disabled={disabled}
					style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
					className={`btn btn-icon btn-sm btn-${
						disabled ? 'light' : color
					} ${className}`}
				>
					<span className={`svg-icon svg-icon-md`}>
						<Visibility />
					</span>
				</button>
			</span>
		</Tooltip>
	);
};

export default EyeIcon;
